export default "__VITE_ASSET__Cg$ZgaIx__"